import { Component, OnInit } from '@angular/core';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { User } from '../../shared/models/User';
import { UserActivity } from '../../shared/models/UserActivity';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-user-activity',
  templateUrl: './user-activity.component.html',
  styleUrls: ['./user-activity.component.css']
})
export class UserActivityComponent implements OnInit {

  CurUser: User;
  UserActivity: UserActivity[];
  Distributors: Distributor[];
  SelectedDistributor: string;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];

  constructor(private global:GlobalService, private http:HttpService) { }

  ngOnInit(): void {
    this.FilterList = [];
    this.CustFilter = new FilterObject();
    this.CustFilter.Key = "distributor";
    this.CustFilter.Value = "";
    this.FilterList.push(this.CustFilter);
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if (this.CurUser && (this.CurUser.IsTolomaticUser)) {
        this.LoadDistributors();
        this.LoadActivity();
      }
    });
    
  }

  LoadActivity() {
    this.http.GetUserActivity(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize).then(wrap => {
      if (wrap.StatusCode == "200") {
        this.UserActivity = wrap.Content;
      }
    });
  }

  LoadDistributors() {
    this.http.GetDistributors().then(wrap => {
      if (wrap.StatusCode == "200") {
        this.Distributors = wrap.Content;
      }
      
    });
  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadActivity();
  }

  Distributor_Change(event: any) {
    this.SelectedDistributor = event.value;
    this.CustFilter.Value = this.SelectedDistributor;
    this.LoadActivity();
  }

}
